

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { postData, putData, serverURL, getData } from "../../../../Services/Fetchnodeservices";

// // ─── Helper: Convert "10:00 AM" → "10:00", "10:00 PM" → "22:00" ───
// const convertTo24Hour = (timeStr) => {
//   if (!timeStr) return "";
//   const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
//   if (match) {
//     let hours = parseInt(match[1]);
//     const minutes = match[2];
//     const ampm = match[3].toUpperCase();
//     if (ampm === "PM" && hours !== 12) hours += 12;
//     if (ampm === "AM" && hours === 12) hours = 0;
//     return `${String(hours).padStart(2, "0")}:${minutes}`;
//   }
//   if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr;
//   return "";
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // ICONS
// // ─────────────────────────────────────────────────────────────────────────────
// const UploadIcon = () => (
//   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//     <path d="M12 3v12m0 0-3-3m3 3 3-3M5 21h14" />
//     <rect x="3" y="15" width="18" height="5" rx="1" />
//   </svg>
// );

// const BackIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <polyline points="15 18 9 12 15 6" />
//   </svg>
// );

// const CheckCircleIcon = () => (
//   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//     <circle cx="12" cy="12" r="10" />
//     <polyline points="12 6 12 12 16 14" />
//   </svg>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN COMPONENT
// // ─────────────────────────────────────────────────────────────────────────────
// const AddNewRestaurant = ({ isDark = true, onBack }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [activeSection, setActiveSection] = useState("personalInfo");

//   const [formData, setFormData] = useState({
//     old_id: "",
//     name: "",
//     organisation_name: "",
//     org_type: "",
//     pre: "",
//     gender: "",
//     contact: "",
//     email: "",
//     password: "",
//     location: "",
//     city: "",
//     state: "",
//     postal: "",
//     address: "",
//     latitude: "",
//     longitude: "",
//     owner_name: "",
//     owner_mobile: "",
//     other_person_name: "",
//     other_person_mobile: "",
//     bank_name: "",
//     bank_branch: "",
//     bank_type: "",
//     account_holder: "",
//     account_number: "",
//     ifsc: "",
//     bank_mobile: "",
//     upi: "",
//     comission: "",
//     special_comission: "",
//     min_order: "",
//     platform_charge: "",
//     handling_charge: "",
//     gst_percentage: "",
//     order_receiving_charges: "",
//     subscription_id: "",
//     paid: "",
//     wallet: "",
//     myreferal: "",
//     refer_by: "",
//     is_mou: "",
//     status: "",
//     hide: "",
//     open_status: "",
//     is_ready: "",
//     shift_start: "",
//     shift_end: "",
//     is_auto_schedule: "",
//     is_schedule_approved: "",
//     is_verify_personalinfo: "",
//     is_verify_docinfo: "",
//     is_verify_bankinfo: "",
//     remarks_personalinfo: "",
//     remarks_docinfo: "",
//     remarks_bankinfo: "",
//     is_menu: "",
//     isKOT: "",
//     isBill: "",
//     menu_direction: "neutral",
//     menu_direction_type: "percentage",
//     menu_direction_value: "",
//     details: "",
//     subject: "",
//     meet_to: "",
//     interestedin: "",
//     gst_number: "",
//     food_license_number: "",
//     created_by_id: "1",
//     is_approved: "",
//     doc_verification: {
//       aadhaar: { status: 0, remarks: "" },
//       pan: { status: 0, remarks: "" },
//       gst: { status: 0, remarks: "" },
//       fssai: { status: 0, remarks: "" },
//     },
//   });

//   const [documents, setDocuments] = useState({
//     pic: null,
//     pic_existing: "",
//     r_logo: null,
//     r_logo_existing: "",
//     h_logo: null,
//     h_logo_existing: "",
//     aadhar_front: null,
//     aadhar_front_existing: "",
//     aadhar_back: null,
//     aadhar_back_existing: "",
//     pan_card: null,
//     pan_card_existing: "",
//     gst_pic: null,
//     gst_pic_existing: "",
//     food_license_pic: null,
//     food_license_pic_existing: "",
//     bank_pass: null,
//     bank_pass_existing: "",
//     cancel_cheque: null,
//     cancel_cheque_existing: "",
//     current_menu_page1: null,
//     current_menu_page1_existing: "",
//     current_menu_page2: null,
//     current_menu_page2_existing: "",
//     current_menu_page3: null,
//     current_menu_page3_existing: "",
//     current_menu_page4: null,
//     current_menu_page4_existing: "",
//     current_menu_page5: null,
//     current_menu_page5_existing: "",
//     current_menu_page6: null,
//     current_menu_page6_existing: "",
//     current_menu_page7: null,
//     current_menu_page7_existing: "",
//     current_menu_page8: null,
//     current_menu_page8_existing: "",
//     current_menu_page9: null,
//     current_menu_page9_existing: "",
//   });

//   const [filledSections, setFilledSections] = useState({
//     personalInfo: false,
//     ownerDetails: false,
//     bankDetails: false,
//     businessSettings: false,
//     statusSchedule: false,
//     verification: false,
//     documents: false,
//     menu: false,
//     meta: false,
//   });

//   const sections = [
//     { id: "personalInfo", label: "Personal Info", icon: "👤" },
//     { id: "ownerDetails", label: "Owner Details", icon: "👥" },
//     { id: "bankDetails", label: "Bank Details", icon: "🏦" },
//     { id: "businessSettings", label: "Business Settings", icon: "⚙️" },
//     { id: "statusSchedule", label: "Status & Schedule", icon: "📅" },
//     { id: "verification", label: "Verification", icon: "✅" },
//     { id: "documents", label: "Documents", icon: "📄" },
//     { id: "menu", label: "Menu", icon: "🍽️" },
//     { id: "meta", label: "Meta", icon: "ℹ️" },
//   ];

//   // ── Load edit data ──
//   useEffect(() => {
//     const loadEditData = async () => {
//       if (location.state?.mode === "edit" && location.state?.restaurantData) {
//         const restaurant = location.state.restaurantData;
//         setIsEditMode(true);
//         setEditId(restaurant.id);

//         try {
//           const response = await getData(`restaurant/Restrunts/${restaurant.id}`);
//           if (response.status && response.data) {
//             const freshData = response.data;
//             Object.assign(restaurant, freshData);
//             console.log("✅ Fresh restaurant data:", restaurant);
//           }
//         } catch (error) {
//           console.warn("Could not fetch fresh data, using passed data", error);
//         }

//         // Parse doc_verification
//         let docVer = {};
//         try {
//           docVer = restaurant.doc_verification ? JSON.parse(restaurant.doc_verification) : {};
//         } catch (e) {}
//         const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
//         docTypes.forEach(doc => {
//           if (!docVer[doc]) docVer[doc] = { status: 0, remarks: "" };
//           if (docVer[doc].status === undefined) docVer[doc].status = 0;
//           if (docVer[doc].remarks === undefined) docVer[doc].remarks = "";
//         });

//         const docInfoVal = restaurant.is_verify_docinfo !== undefined ? Number(restaurant.is_verify_docinfo) : 0;
//         if (docInfoVal === 1) {
//           docTypes.forEach(doc => {
//             if (docVer[doc]) docVer[doc].status = 1;
//           });
//         }

//         // ── Ensure status fields are strings ──
//         const toStr = (val) => (val !== undefined && val !== null) ? String(val) : "";

//         const shiftStart24 = convertTo24Hour(restaurant.shift_start);
//         const shiftEnd24 = convertTo24Hour(restaurant.shift_end);

//         setFormData({
//           old_id: restaurant.old_id || restaurant.id || "",
//           name: restaurant.name || "",
//           organisation_name: restaurant.organisation_name || "",
//           org_type: restaurant.org_type || "",
//           pre: restaurant.pre || "",
//           gender: restaurant.gender || "",
//           contact: restaurant.contact || "",
//           email: restaurant.email || "",
//           password: "",
//           location: restaurant.location || "",
//           city: restaurant.city || "",
//           state: restaurant.state || "",
//           postal: restaurant.postal || "",
//           address: restaurant.address || "",
//           latitude: restaurant.latitude || "",
//           longitude: restaurant.longitude || "",
//           owner_name: restaurant.owner_name || "",
//           owner_mobile: restaurant.owner_mobile || "",
//           other_person_name: restaurant.other_person_name || "",
//           other_person_mobile: restaurant.other_person_mobile || "",
//           bank_name: restaurant.bank_name || "",
//           bank_branch: restaurant.bank_branch || "",
//           bank_type: restaurant.bank_type || "",
//           account_holder: restaurant.account_holder || "",
//           account_number: restaurant.account_number || "",
//           ifsc: restaurant.ifsc || "",
//           bank_mobile: restaurant.bank_mobile || "",
//           upi: restaurant.upi || "",
//           comission: restaurant.comission || "",
//           special_comission: restaurant.special_comission || "",
//           min_order: restaurant.min_order || "",
//           platform_charge: restaurant.platform_charge || "",
//           handling_charge: restaurant.handling_charge || "",
//           gst_percentage: restaurant.gst_percentage || "",
//           order_receiving_charges: restaurant.order_receiving_charges || "",
//           subscription_id: restaurant.subscription_id || "",
//           paid: toStr(restaurant.paid),
//           wallet: restaurant.wallet || "0",
//           myreferal: restaurant.myreferal || "",
//           refer_by: restaurant.refer_by || "",
//           is_mou: toStr(restaurant.is_mou),
//           status: toStr(restaurant.status),
//           hide: toStr(restaurant.hide),
//           open_status: toStr(restaurant.open_status),
//           is_ready: toStr(restaurant.is_ready),
//           shift_start: shiftStart24,
//           shift_end: shiftEnd24,
//           is_auto_schedule: toStr(restaurant.is_auto_schedule),
//           is_schedule_approved: toStr(restaurant.is_schedule_approved),
//           is_verify_personalinfo: toStr(restaurant.is_verify_personalinfo),
//           is_verify_docinfo: toStr(restaurant.is_verify_docinfo),
//           is_verify_bankinfo: toStr(restaurant.is_verify_bankinfo),
//           remarks_personalinfo: restaurant.remarks_personalinfo || "",
//           remarks_docinfo: restaurant.remarks_docinfo || "",
//           remarks_bankinfo: restaurant.remarks_bankinfo || "",
//           is_menu: toStr(restaurant.is_menu),
//           isKOT: toStr(restaurant.isKOT),
//           isBill: toStr(restaurant.isBill),
//           menu_direction: restaurant.menu_direction || "neutral",
//           menu_direction_type: restaurant.menu_direction_type || "percentage",
//           menu_direction_value: restaurant.menu_direction_value || "",
//           details: restaurant.details || "",
//           subject: restaurant.subject || "",
//           meet_to: restaurant.meet_to || "",
//           interestedin: restaurant.interestedin || "",
//           gst_number: restaurant.gst_number || "",
//           food_license_number: restaurant.food_license_number || "",
//           created_by_id: restaurant.created_by_id || "1",
//           is_approved: toStr(restaurant.is_approved), // ✅ Ensure string "0" or "1"
//           doc_verification: docVer,
//         });

//         setDocuments((prev) => ({
//           ...prev,
//           pic_existing: restaurant.pic || "",
//           h_logo_existing: restaurant.h_logo || "",
//           r_logo_existing: restaurant.r_logo || "",
//           aadhar_front_existing: restaurant.aadhar_front || "",
//           aadhar_back_existing: restaurant.aadhar_back || "",
//           pan_card_existing: restaurant.pan_card || "",
//           gst_pic_existing: restaurant.gst_pic || "",
//           food_license_pic_existing: restaurant.food_license_pic || "",
//           bank_pass_existing: restaurant.bank_pass || "",
//           cancel_cheque_existing: restaurant.cancel_cheque || "",
//           current_menu_page1_existing: restaurant.current_menu_page1 || "",
//           current_menu_page2_existing: restaurant.current_menu_page2 || "",
//           current_menu_page3_existing: restaurant.current_menu_page3 || "",
//           current_menu_page4_existing: restaurant.current_menu_page4 || "",
//           current_menu_page5_existing: restaurant.current_menu_page5 || "",
//           current_menu_page6_existing: restaurant.current_menu_page6 || "",
//           current_menu_page7_existing: restaurant.current_menu_page7 || "",
//           current_menu_page8_existing: restaurant.current_menu_page8 || "",
//           current_menu_page9_existing: restaurant.current_menu_page9 || "",
//         }));

//         const allFilled = {};
//         Object.keys(filledSections).forEach((key) => {
//           allFilled[key] = true;
//         });
//         setFilledSections(allFilled);
//       }
//     };
//     loadEditData();
//   }, [location.state]);

//   // ── Auto‑sync: when doc_verification changes, recompute is_verify_docinfo ──
//   useEffect(() => {
//     const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
//     const allVerified = docTypes.every(doc => formData.doc_verification[doc]?.status === 1);
//     const newDocInfo = allVerified ? 1 : 0;
//     if (Number(formData.is_verify_docinfo) !== newDocInfo) {
//       setFormData(prev => ({
//         ...prev,
//         is_verify_docinfo: newDocInfo.toString()
//       }));
//     }
//   }, [formData.doc_verification]);

//   // ── Handlers ──
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name.startsWith("doc_verification.")) {
//       const parts = name.split(".");
//       const docType = parts[1];
//       const field = parts[2];
//       setFormData((prev) => ({
//         ...prev,
//         doc_verification: {
//           ...prev.doc_verification,
//           [docType]: {
//             ...prev.doc_verification[docType],
//             [field]: field === "status" ? parseInt(value) : value,
//           },
//         },
//       }));
//       return;
//     }

//     if (name === "is_verify_docinfo") {
//       const docInfoVal = parseInt(value) || 0;
//       const newDocVer = { ...formData.doc_verification };
//       const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
//       docTypes.forEach(doc => {
//         if (newDocVer[doc]) {
//           newDocVer[doc].status = docInfoVal;
//         }
//       });
//       setFormData({
//         ...formData,
//         [name]: value,
//         doc_verification: newDocVer,
//       });
//       return;
//     }

//     setFormData({ ...formData, [name]: value });
//     checkSectionFilled(activeSection, { ...formData, [name]: value });
//   };

//   const handleFileUpload = (docName, file) => {
//     setDocuments({ ...documents, [docName]: file });
//   };

//   const checkSectionFilled = (section, data) => {
//     let isFilled = false;
//     switch (section) {
//       case "personalInfo":
//         isFilled = !!data.name || !!data.contact || !!data.email;
//         break;
//       case "ownerDetails":
//         isFilled = !!data.owner_name || !!data.owner_mobile;
//         break;
//       case "bankDetails":
//         isFilled = !!data.bank_name || !!data.account_number || !!data.ifsc;
//         break;
//       case "businessSettings":
//         isFilled = !!data.comission || !!data.min_order;
//         break;
//       case "statusSchedule":
//         isFilled = !!data.status;
//         break;
//       case "verification":
//         isFilled =
//           !!data.is_verify_personalinfo ||
//           !!data.is_verify_docinfo ||
//           !!data.is_verify_bankinfo ||
//           data.is_approved !== "";
//         break;
//       case "documents":
//         const hasDoc = Object.keys(documents).some((key) => {
//           if (key.includes("_existing")) return false;
//           return documents[key] !== null && documents[key] !== "";
//         });
//         isFilled = hasDoc;
//         break;
//       case "menu":
//         isFilled = !!data.is_menu;
//         break;
//       case "meta":
//         isFilled = !!data.details;
//         break;
//       default:
//         isFilled = false;
//     }
//     setFilledSections((prev) => ({ ...prev, [section]: isFilled }));
//   };

//   const completedCount = Object.values(filledSections).filter((v) => v === true).length;
//   const progressPercentage = (completedCount / sections.length) * 100;

//   // ── Submit ──
//   const handleSubmit = async (e) => {
//     if (e) e.preventDefault();
//     setLoading(true);

//     try {
//       const data = new FormData();

//       const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
//       let docVer = { ...formData.doc_verification };
//       docTypes.forEach(doc => {
//         if (!docVer[doc]) docVer[doc] = { status: 0, remarks: "" };
//         if (docVer[doc].status === undefined || docVer[doc].status === null) {
//           docVer[doc].status = 0;
//         }
//         if (docVer[doc].remarks === undefined) {
//           docVer[doc].remarks = "";
//         }
//       });

//       Object.keys(formData).forEach((key) => {
//         if (key === "password" && !formData[key] && isEditMode) {
//           return;
//         }
//         if (key === "doc_verification") {
//           data.append(key, JSON.stringify(docVer));
//         } else {
//           data.append(key, formData[key] || "");
//         }
//       });

//       const fileFields = [
//         "pic", "r_logo", "h_logo", "aadhar_front", "aadhar_back",
//         "pan_card", "gst_pic", "food_license_pic", "bank_pass", "cancel_cheque",
//         "current_menu_page1", "current_menu_page2", "current_menu_page3",
//         "current_menu_page4", "current_menu_page5", "current_menu_page6",
//         "current_menu_page7", "current_menu_page8", "current_menu_page9",
//       ];

//       fileFields.forEach((field) => {
//         if (documents[field] && documents[field] instanceof File) {
//           data.append(field, documents[field]);
//         }
//       });

//       let response;
//       if (isEditMode && editId) {
//         data.append("id", editId);
//         response = await postData(`restaurant/updaterestaurant/${editId}`, data);
//       } else {
//         response = await postData("resturant/addrestaurant", data);
//       }

//       if (response.status || response.data?.status) {
//         alert(isEditMode ? "Restaurant Updated Successfully" : "Restaurant Added Successfully");
//         if (onBack) onBack();
//         else navigate("/Dashboard/restaurants");
//       } else {
//         alert(response.data?.message || response.message || "Failed to save restaurant");
//       }
//     } catch (error) {
//       console.log(error);
//       alert(error?.response?.data?.message || error?.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     if (onBack) onBack();
//     else navigate("/Dashboard/restaurants");
//   };

//   // ── Styles (same as before, no changes) ──
//   const styles = {
//     container: {
//       background: isDark ? "#0d1117" : "#f8fafc",
//       fontFamily: "'Segoe UI', 'DM Sans', sans-serif",
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//     },
//     header: {
//       display: "flex",
//       alignItems: "center",
//       gap: "16px",
//       padding: "16px 24px",
//       borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       background: isDark ? "#0d1117" : "#f8fafc",
//       position: "sticky",
//       top: 0,
//       zIndex: 10,
//     },
//     backBtn: {
//       background: "none",
//       border: "none",
//       cursor: "pointer",
//       color: isDark ? "#94a3b8" : "#64748b",
//       display: "flex",
//       alignItems: "center",
//       gap: "6px",
//       fontSize: "14px",
//       padding: "8px 12px",
//       borderRadius: "8px",
//     },
//     headerTitle: {
//       fontSize: "20px",
//       fontWeight: 700,
//       color: isDark ? "#f1f5f9" : "#1e293b",
//       margin: 0,
//       flex: 1,
//     },
//     progressContainer: {
//       padding: "12px 24px",
//       background: isDark ? "#0d1117" : "#f8fafc",
//       borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//     },
//     progressHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       marginBottom: "8px",
//     },
//     progressLabel: {
//       fontSize: "12px",
//       fontWeight: 600,
//       color: isDark ? "#64748b" : "#475569",
//     },
//     progressPercent: {
//       fontSize: "12px",
//       fontWeight: 700,
//       color: "#4a6cf7",
//     },
//     progressBarBg: {
//       background: isDark ? "#1e2740" : "#e2e8f0",
//       borderRadius: "10px",
//       height: "6px",
//       overflow: "hidden",
//     },
//     progressBarFill: {
//       background: "linear-gradient(90deg, #4a6cf7, #8b5cf6)",
//       width: `${progressPercentage}%`,
//       height: "100%",
//       borderRadius: "10px",
//       transition: "width 0.3s ease",
//     },
//     sectionButtons: {
//       display: "flex",
//       gap: "8px",
//       padding: "16px 24px",
//       overflowX: "auto",
//       background: isDark ? "#0d1117" : "#f8fafc",
//       borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       scrollbarWidth: "thin",
//     },
//     sectionBtn: (isActive, isCompleted) => ({
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       padding: "10px 16px",
//       borderRadius: "10px",
//       fontSize: "13px",
//       fontWeight: 600,
//       cursor: "pointer",
//       transition: "all 0.2s",
//       background: isActive
//         ? "#4a6cf7"
//         : isDark
//         ? "#141824"
//         : "#ffffff",
//       border: isActive
//         ? "1px solid #4a6cf7"
//         : isDark
//         ? "1px solid #1e2740"
//         : "1px solid #e2e8f0",
//       color: isActive
//         ? "#ffffff"
//         : isDark
//         ? "#94a3b8"
//         : "#64748b",
//       whiteSpace: "nowrap",
//     }),
//     formContainer: {
//       flex: 1,
//       overflowY: "auto",
//       padding: "24px",
//     },
//     formCard: {
//       background: isDark ? "#141824" : "#ffffff",
//       border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       borderRadius: "16px",
//       padding: "24px",
//     },
//     formTitle: {
//       fontSize: "18px",
//       fontWeight: 700,
//       color: isDark ? "#f1f5f9" : "#1e293b",
//       marginBottom: "20px",
//       paddingBottom: "12px",
//       borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//     },
//     formGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//       gap: "20px",
//     },
//     formGrid3: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
//       gap: "16px",
//     },
//     inputGroup: {
//       display: "flex",
//       flexDirection: "column",
//       gap: "6px",
//     },
//     label: {
//       fontSize: "12px",
//       fontWeight: 600,
//       color: isDark ? "#64748b" : "#475569",
//       letterSpacing: "0.3px",
//     },
//     input: {
//       padding: "10px 14px",
//       background: isDark ? "#0f1520" : "#f8fafc",
//       border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       borderRadius: "8px",
//       fontSize: "13px",
//       color: isDark ? "#e2e8f0" : "#1e293b",
//       outline: "none",
//       transition: "all 0.2s",
//     },
//     select: {
//       padding: "10px 14px",
//       background: isDark ? "#0f1520" : "#f8fafc",
//       border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       borderRadius: "8px",
//       fontSize: "13px",
//       color: isDark ? "#e2e8f0" : "#1e293b",
//       outline: "none",
//       cursor: "pointer",
//     },
//     textarea: {
//       padding: "10px 14px",
//       background: isDark ? "#0f1520" : "#f8fafc",
//       border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       borderRadius: "8px",
//       fontSize: "13px",
//       color: isDark ? "#e2e8f0" : "#1e293b",
//       outline: "none",
//       fontFamily: "inherit",
//       resize: "vertical",
//       minHeight: "80px",
//     },
//     documentGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
//       gap: "16px",
//     },
//     uploadBox: {
//       border: isDark ? "1px dashed #1e2740" : "1px dashed #cbd5e1",
//       borderRadius: "12px",
//       padding: "16px",
//       textAlign: "center",
//       cursor: "pointer",
//       transition: "all 0.2s",
//       background: isDark ? "#0f1520" : "#f8fafc",
//       position: "relative",
//     },
//     uploadLabel: {
//       fontSize: "12px",
//       color: isDark ? "#64748b" : "#94a3b8",
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       gap: "8px",
//       cursor: "pointer",
//     },
//     existingImage: {
//       maxWidth: "100%",
//       maxHeight: "80px",
//       borderRadius: "4px",
//       objectFit: "cover",
//       marginTop: "8px",
//     },
//     removeBtn: {
//       position: "absolute",
//       top: "4px",
//       right: "4px",
//       background: "#ef4444",
//       border: "none",
//       borderRadius: "50%",
//       width: "22px",
//       height: "22px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       cursor: "pointer",
//       color: "#fff",
//       fontSize: "12px",
//     },
//     fixedButtons: {
//       position: "sticky",
//       bottom: 0,
//       padding: "16px 24px",
//       background: isDark ? "#0d1117" : "#f8fafc",
//       borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       display: "flex",
//       justifyContent: "flex-end",
//       gap: "12px",
//       zIndex: 10,
//     },
//     cancelBtn: {
//       padding: "10px 24px",
//       background: "transparent",
//       border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       borderRadius: "8px",
//       fontSize: "13px",
//       fontWeight: 600,
//       color: isDark ? "#94a3b8" : "#64748b",
//       cursor: "pointer",
//     },
//     createBtn: {
//       padding: "10px 24px",
//       background: "#4a6cf7",
//       border: "none",
//       borderRadius: "8px",
//       fontSize: "13px",
//       fontWeight: 600,
//       color: "#fff",
//       cursor: "pointer",
//     },
//     infoRow: {
//       display: "flex",
//       alignItems: "center",
//       gap: "16px",
//       padding: "12px 0",
//       borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//     },
//     infoLabel: {
//       fontSize: "12px",
//       fontWeight: 600,
//       color: isDark ? "#64748b" : "#475569",
//       width: "120px",
//     },
//     infoValue: {
//       fontSize: "13px",
//       color: isDark ? "#e2e8f0" : "#1e293b",
//       flex: 1,
//     },
//     navButtons: {
//       display: "flex",
//       justifyContent: "space-between",
//       marginTop: "24px",
//       paddingTop: "20px",
//       borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//     },
//     navBtn: {
//       padding: "8px 20px",
//       borderRadius: "8px",
//       fontSize: "13px",
//       fontWeight: 600,
//       cursor: "pointer",
//       border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
//       background: isDark ? "#0f1520" : "#f8fafc",
//       color: isDark ? "#94a3b8" : "#64748b",
//     },
//     navBtnPrimary: {
//       padding: "8px 20px",
//       borderRadius: "8px",
//       fontSize: "13px",
//       fontWeight: 600,
//       cursor: "pointer",
//       background: "#4a6cf7",
//       border: "none",
//       color: "#fff",
//     },
//     infoBox: {
//       background: isDark ? "#0f1520" : "#f0fdf4",
//       border: `1px solid ${isDark ? "#1e2740" : "#bbf7d0"}`,
//       borderRadius: "12px",
//       padding: "16px",
//       marginBottom: "20px",
//     },
//     infoTitle: {
//       fontSize: "13px",
//       fontWeight: 600,
//       color: isDark ? "#f1f5f9" : "#166534",
//       marginBottom: "8px",
//     },
//     infoDesc: {
//       fontSize: "12px",
//       color: isDark ? "#94a3b8" : "#15803d",
//     },
//   };

//   // ── Helper: Get image URL ──
//   const getImageUrl = (filename) => {
//     if (!filename) return null;
//     if (filename.startsWith("http")) return filename;
//     if (filename.startsWith("blob:")) return filename;
//     return `${serverURL}/public/uploadnew/upload/${filename}`;
//   };

//   // ── File Upload Field ──
//   const FileUploadField = ({ label, docKey }) => {
//     const file = documents[docKey];
//     const existingFile = documents[`${docKey}_existing`];
//     const hasFile = file instanceof File || (existingFile && existingFile !== "");

//     let imageUrl = null;
//     if (file instanceof File) {
//       imageUrl = URL.createObjectURL(file);
//     } else if (existingFile) {
//       imageUrl = getImageUrl(existingFile);
//     }

//     return (
//       <div style={styles.uploadBox}>
//         <label style={styles.uploadLabel}>
//           <input
//             type="file"
//             style={{ display: "none" }}
//             onChange={(e) => {
//               if (e.target.files && e.target.files[0]) {
//                 handleFileUpload(docKey, e.target.files[0]);
//               }
//             }}
//           />
//           <UploadIcon />
//           <span style={{ fontSize: "11px", wordBreak: "break-all" }}>
//             {file instanceof File ? file.name : existingFile ? existingFile : label}
//           </span>
//         </label>
//         {imageUrl && (
//           <div style={{ marginTop: "8px" }}>
//             <img src={imageUrl} alt={label} style={styles.existingImage} />
//           </div>
//         )}
//         {hasFile && (
//           <button
//             style={styles.removeBtn}
//             onClick={(e) => {
//               e.stopPropagation();
//               setDocuments((prev) => ({ ...prev, [docKey]: null }));
//             }}
//             type="button"
//           >
//             ✕
//           </button>
//         )}
//       </div>
//     );
//   };

//   // ── Render each section ──
//   const renderForm = () => {
//     switch (activeSection) {
//       case "personalInfo":
//         return (
//           <div style={styles.formGrid}>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Old ID</label>
//               <input style={styles.input} name="old_id" value={formData.old_id} onChange={handleChange} placeholder="Old ID" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Restaurant Name *</label>
//               <input style={styles.input} name="name" value={formData.name} onChange={handleChange} placeholder="Enter restaurant name" required />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Organisation Name</label>
//               <input style={styles.input} name="organisation_name" value={formData.organisation_name} onChange={handleChange} placeholder="Organisation name" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Org Type</label>
//               <select style={styles.select} name="org_type" value={formData.org_type} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="0">Individual</option>
//                 <option value="1">Partnership</option>
//                 <option value="2">Company</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Prefix</label>
//               <select style={styles.select} name="pre" value={formData.pre} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="Mr.">Mr.</option>
//                 <option value="Ms.">Ms.</option>
//                 <option value="Mrs.">Mrs.</option>
//                 <option value="Dr.">Dr.</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Gender</label>
//               <select style={styles.select} name="gender" value={formData.gender} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="Male">Male</option>
//                 <option value="Female">Female</option>
//                 <option value="Other">Other</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Contact Number *</label>
//               <input style={styles.input} name="contact" value={formData.contact} onChange={handleChange} placeholder="+91 98765 43210" required />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Email *</label>
//               <input style={styles.input} name="email" type="email" value={formData.email} onChange={handleChange} placeholder="restaurant@example.com" required />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Password {!isEditMode && "*"}</label>
//               <input style={styles.input} name="password" type="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required={!isEditMode} />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>City</label>
//               <input style={styles.input} name="city" value={formData.city} onChange={handleChange} placeholder="Enter city" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>State</label>
//               <input style={styles.input} name="state" value={formData.state} onChange={handleChange} placeholder="Enter state" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>PIN Code</label>
//               <input style={styles.input} name="postal" value={formData.postal} onChange={handleChange} placeholder="6-digit PIN" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Address</label>
//               <textarea style={styles.textarea} name="address" value={formData.address} onChange={handleChange} placeholder="Full address" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Latitude</label>
//               <input style={styles.input} name="latitude" value={formData.latitude} onChange={handleChange} placeholder="Latitude" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Longitude</label>
//               <input style={styles.input} name="longitude" value={formData.longitude} onChange={handleChange} placeholder="Longitude" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Round Logo</label>
//               <FileUploadField label="Upload Round Logo" docKey="pic" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Horizontal Logo</label>
//               <FileUploadField label="Upload Horizontal Logo" docKey="h_logo" />
//             </div>
//           </div>
//         );

//       case "ownerDetails":
//         return (
//           <div style={styles.formGrid}>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Owner Name</label>
//               <input style={styles.input} name="owner_name" value={formData.owner_name} onChange={handleChange} placeholder="Full name" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Owner Mobile</label>
//               <input style={styles.input} name="owner_mobile" value={formData.owner_mobile} onChange={handleChange} placeholder="+91 XXXXX XXXXX" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Other Person Name</label>
//               <input style={styles.input} name="other_person_name" value={formData.other_person_name} onChange={handleChange} placeholder="Optional" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Other Person Mobile</label>
//               <input style={styles.input} name="other_person_mobile" value={formData.other_person_mobile} onChange={handleChange} placeholder="Optional" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Meet To</label>
//               <input style={styles.input} name="meet_to" value={formData.meet_to || ""} onChange={handleChange} placeholder="Meet To" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Interested In</label>
//               <input style={styles.input} name="interestedin" value={formData.interestedin || ""} onChange={handleChange} placeholder="Interested In" />
//             </div>
//           </div>
//         );

//       case "bankDetails":
//         return (
//           <>
//             <div style={styles.formGrid}>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Bank Name</label>
//                 <input style={styles.input} name="bank_name" value={formData.bank_name} onChange={handleChange} placeholder="Bank name" />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Branch</label>
//                 <input style={styles.input} name="bank_branch" value={formData.bank_branch} onChange={handleChange} placeholder="Branch name" />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Bank Type</label>
//                 <select style={styles.select} name="bank_type" value={formData.bank_type} onChange={handleChange}>
//                   <option value="">Select</option>
//                   <option value="Savings">Savings</option>
//                   <option value="Current">Current</option>
//                 </select>
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Account Holder</label>
//                 <input style={styles.input} name="account_holder" value={formData.account_holder} onChange={handleChange} placeholder="Account holder name" />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Account Number</label>
//                 <input style={styles.input} name="account_number" value={formData.account_number} onChange={handleChange} placeholder="Account number" />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>IFSC Code</label>
//                 <input style={styles.input} name="ifsc" value={formData.ifsc} onChange={handleChange} placeholder="IFSC code" />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Bank Mobile</label>
//                 <input style={styles.input} name="bank_mobile" value={formData.bank_mobile} onChange={handleChange} placeholder="Registered mobile" />
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>UPI</label>
//                 <input style={styles.input} name="upi" value={formData.upi || ""} onChange={handleChange} placeholder="UPI ID" />
//               </div>
//             </div>
//             <div style={{ marginTop: "16px", display: "flex", justifyContent: "space-evenly", flexWrap: "wrap", gap: "10px" }}>
//               <FileUploadField label="Bank Passbook" docKey="bank_pass" />
//               <FileUploadField label="Cancel Cheque" docKey="cancel_cheque" />
//             </div>
//           </>
//         );

//       case "businessSettings":
//         return (
//           <div style={styles.formGrid}>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Commission (%)</label>
//               <input style={styles.input} name="comission" value={formData.comission} onChange={handleChange} placeholder="e.g., 10" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Special Commission (%)</label>
//               <input style={styles.input} name="special_comission" value={formData.special_comission} onChange={handleChange} placeholder="e.g., 5" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Minimum Order (₹)</label>
//               <input style={styles.input} name="min_order" value={formData.min_order} onChange={handleChange} placeholder="₹" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Platform Charge (₹)</label>
//               <input style={styles.input} name="platform_charge" value={formData.platform_charge} onChange={handleChange} placeholder="₹" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Handling Charge (%)</label>
//               <input style={styles.input} name="handling_charge" value={formData.handling_charge} onChange={handleChange} placeholder="%" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>GST (%)</label>
//               <input style={styles.input} name="gst_percentage" value={formData.gst_percentage} onChange={handleChange} placeholder="%" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Order Receiving Charges (%)</label>
//               <input style={styles.input} name="order_receiving_charges" value={formData.order_receiving_charges} onChange={handleChange} placeholder="%" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Subscription</label>
//               <select style={styles.select} name="subscription_id" value={formData.subscription_id} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Basic</option>
//                 <option value="2">Premium</option>
//                 <option value="3">Enterprise</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Paid Status</label>
//               <select style={styles.select} name="paid" value={formData.paid} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Paid</option>
//                 <option value="0">Unpaid</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Wallet (₹)</label>
//               <input style={styles.input} name="wallet" value={formData.wallet} onChange={handleChange} placeholder="₹" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Referral Code</label>
//               <input style={styles.input} name="myreferal" value={formData.myreferal} onChange={handleChange} placeholder="Referral code" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Referred By</label>
//               <input style={styles.input} name="refer_by" value={formData.refer_by} onChange={handleChange} placeholder="Referrer" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>MOU Signed</label>
//               <select style={styles.select} name="is_mou" value={formData.is_mou} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Yes</option>
//                 <option value="0">No</option>
//               </select>
//             </div>
//           </div>
//         );

//       case "statusSchedule":
//         return (
//           <div style={styles.formGrid}>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Status</label>
//               <select style={styles.select} name="status" value={formData.status} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Active</option>
//                 <option value="0">Inactive</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Hide</label>
//               <select style={styles.select} name="hide" value={formData.hide} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Yes</option>
//                 <option value="0">No</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Schedule Mode</label>
//               <select style={styles.select} name="is_auto_schedule" value={formData.is_auto_schedule} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Auto</option>
//                 <option value="0">Manual</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Shift Start</label>
//               <input style={styles.input} name="shift_start" type="time" value={formData.shift_start} onChange={handleChange} />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Shift End</label>
//               <input style={styles.input} name="shift_end" type="time" value={formData.shift_end} onChange={handleChange} />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Open Status</label>
//               <select style={styles.select} name="open_status" value={formData.open_status} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Open</option>
//                 <option value="0">Closed</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Schedule Approved</label>
//               <select style={styles.select} name="is_schedule_approved" value={formData.is_schedule_approved} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Yes</option>
//                 <option value="0">No</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Is Ready</label>
//               <select style={styles.select} name="is_ready" value={formData.is_ready} onChange={handleChange}>
//                 <option value="">Select</option>
//                 <option value="1">Yes</option>
//                 <option value="0">No</option>
//               </select>
//             </div>
//           </div>
//         );

//       case "verification":
//         return (
//           <div style={styles.formGrid}>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Personal Info Verified</label>
//               <select style={styles.select} name="is_verify_personalinfo" value={formData.is_verify_personalinfo} onChange={handleChange}>
//                 <option value="">Select...</option>
//                 <option value="1">Verified</option>
//                 <option value="0">Pending</option>
//                 <option value="2">Rejected</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Remarks (Personal)</label>
//               <input style={styles.input} name="remarks_personalinfo" value={formData.remarks_personalinfo} onChange={handleChange} placeholder="Remarks" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Bank Verified</label>
//               <select style={styles.select} name="is_verify_bankinfo" value={formData.is_verify_bankinfo} onChange={handleChange}>
//                 <option value="">Select...</option>
//                 <option value="1">Verified</option>
//                 <option value="0">Pending</option>
//                 <option value="2">Rejected</option>
//               </select>
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Remarks (Bank)</label>
//               <input style={styles.input} name="remarks_bankinfo" value={formData.remarks_bankinfo} onChange={handleChange} placeholder="Remarks" />
//             </div>

//             <div style={{ gridColumn: "1 / -1", marginTop: "20px", borderTop: "1px solid " + (isDark ? "#1e2740" : "#e2e8f0"), paddingTop: "20px" }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//                 <h4 style={{ fontSize: "14px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>
//                   Document-wise Verification
//                 </h4>
//                 <span style={{ fontSize: "12px", color: isDark ? "#94a3b8" : "#64748b" }}>
//                   Overall Doc Status: {formData.is_verify_docinfo === "1" ? "✅ Verified" : "⏳ Pending"}
//                 </span>
//               </div>
//               {["aadhaar", "pan", "gst", "fssai"].map((doc) => {
//                 const docData = formData.doc_verification?.[doc] || { status: 0, remarks: "" };
//                 const statusMap = { 0: "Pending", 1: "Verified", 2: "Rejected" };
//                 return (
//                   <div key={doc} style={{ ...styles.inputGroup, marginBottom: "16px" }}>
//                     <label style={styles.label}>{doc.toUpperCase()}</label>
//                     <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
//                       <select
//                         style={{ ...styles.select, flex: 1, minWidth: "120px" }}
//                         value={docData.status}
//                         onChange={(e) => {
//                           const newDocVer = { ...formData.doc_verification };
//                           if (!newDocVer[doc]) newDocVer[doc] = {};
//                           newDocVer[doc].status = parseInt(e.target.value);
//                           setFormData({ ...formData, doc_verification: newDocVer });
//                         }}
//                       >
//                         <option value="0">Pending</option>
//                         <option value="1">Verified</option>
//                         <option value="2">Rejected</option>
//                       </select>
//                       <input
//                         style={{ ...styles.input, flex: 2 }}
//                         placeholder="Remarks"
//                         value={docData.remarks || ""}
//                         onChange={(e) => {
//                           const newDocVer = { ...formData.doc_verification };
//                           if (!newDocVer[doc]) newDocVer[doc] = {};
//                           newDocVer[doc].remarks = e.target.value;
//                           setFormData({ ...formData, doc_verification: newDocVer });
//                         }}
//                       />
//                       <span style={{ fontSize: "11px", color: isDark ? "#94a3b8" : "#64748b", minWidth: "70px" }}>
//                         {statusMap[docData.status] || "Pending"}
//                       </span>
//                     </div>
//                   </div>
//                 );
//               })}
//               <div style={{ fontSize: "12px", color: isDark ? "#94a3b8" : "#64748b", marginTop: "8px" }}>
//                 ⚠️ Changing the overall "Document Verified" dropdown will automatically set all individual doc statuses.
//               </div>
//             </div>

//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Approval Status</label>
//               <select style={styles.select} name="is_approved" value={formData.is_approved} onChange={handleChange}>
//                 <option value="">Select...</option>
//                 <option value="0">Pending</option>
//                 <option value="1">Approved</option>
//               </select>
//               <small style={{ color: isDark ? "#94a3b8" : "#64748b", fontSize: "11px" }}>
//                 {formData.is_approved === "1"
//                   ? "✅ Approved – vendor can log in"
//                   : formData.is_approved === "0"
//                   ? "⏳ Pending approval"
//                   : "Not set"}
//               </small>
//             </div>
//           </div>
//         );

//       case "documents":
//         return (
//           <div style={styles.documentGrid}>
//             <FileUploadField label="Aadhar Front" docKey="aadhar_front" />
//             <FileUploadField label="Aadhar Back" docKey="aadhar_back" />
//             <FileUploadField label="Pan Card" docKey="pan_card" />
//             <FileUploadField label="GST Image" docKey="gst_pic" />
//             <FileUploadField label="Food License" docKey="food_license_pic" />
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>GST Number</label>
//               <input type="text" style={styles.input} name="gst_number" value={formData.gst_number || ""} onChange={handleChange} placeholder="Enter GST Number" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Food License Number</label>
//               <input type="text" style={styles.input} name="food_license_number" value={formData.food_license_number || ""} onChange={handleChange} placeholder="Enter Food License Number" />
//             </div>
//           </div>
//         );

//       case "menu":
//         return (
//           <>
//             <div style={styles.formGrid3}>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Menu Uploaded</label>
//                 <select style={styles.select} name="is_menu" value={formData.is_menu} onChange={handleChange}>
//                   <option value="">Select...</option>
//                   <option value="1">Yes</option>
//                   <option value="0">No</option>
//                 </select>
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>KOT Enabled</label>
//                 <select style={styles.select} name="isKOT" value={formData.isKOT} onChange={handleChange}>
//                   <option value="">Select...</option>
//                   <option value="1">Yes</option>
//                   <option value="0">No</option>
//                 </select>
//               </div>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Bill Enabled</label>
//                 <select style={styles.select} name="isBill" value={formData.isBill} onChange={handleChange}>
//                   <option value="">Select...</option>
//                   <option value="1">Yes</option>
//                   <option value="0">No</option>
//                 </select>
//               </div>
//             </div>
//             <div style={{ ...styles.infoBox, marginTop: "20px" }}>
//               <div style={styles.infoTitle}>📊 Menu Price Adjustment</div>
//               <div style={styles.infoDesc}>
//                 {formData.menu_direction === "neutral" && "No price adjustment applied."}
//                 {formData.menu_direction === "above" &&
//                   `✓ ${formData.menu_direction_type === "fixed" ? `₹${formData.menu_direction_value || 0}` : `${formData.menu_direction_value || 0}%`} will be ADDED to all menu items.`}
//                 {formData.menu_direction === "below" &&
//                   `✓ ${formData.menu_direction_type === "fixed" ? `₹${formData.menu_direction_value || 0}` : `${formData.menu_direction_value || 0}%`} will be DEDUCTED from all menu items.`}
//               </div>
//             </div>
//             <div style={styles.formGrid}>
//               <div style={styles.inputGroup}>
//                 <label style={styles.label}>Menu Direction</label>
//                 <select style={styles.select} name="menu_direction" value={formData.menu_direction} onChange={handleChange}>
//                   <option value="neutral">Neutral (No Change)</option>
//                   <option value="above">Above (Add)</option>
//                   <option value="below">Below (Subtract)</option>
//                 </select>
//               </div>
//               {formData.menu_direction !== "neutral" && (
//                 <>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Direction Type</label>
//                     <select style={styles.select} name="menu_direction_type" value={formData.menu_direction_type} onChange={handleChange}>
//                       <option value="fixed">Fixed (₹)</option>
//                       <option value="percentage">Percentage (%)</option>
//                     </select>
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>
//                       {formData.menu_direction_type === "fixed" ? "Value (₹)" : "Value (%)"}
//                     </label>
//                     <input
//                       style={styles.input}
//                       name="menu_direction_value"
//                       value={formData.menu_direction_value}
//                       onChange={handleChange}
//                       type="number"
//                       step={formData.menu_direction_type === "fixed" ? "1" : "0.01"}
//                       placeholder={formData.menu_direction_type === "fixed" ? "e.g., 50" : "e.g., 10"}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//             <div style={{ marginTop: "20px" }}>
//               <h4 style={{ ...styles.label, marginBottom: "12px", fontSize: "13px" }}>Menu Pages</h4>
//               <div style={styles.documentGrid}>
//                 <FileUploadField label="Page 1" docKey="current_menu_page1" />
//                 <FileUploadField label="Page 2" docKey="current_menu_page2" />
//                 <FileUploadField label="Page 3" docKey="current_menu_page3" />
//                 <FileUploadField label="Page 4" docKey="current_menu_page4" />
//                 <FileUploadField label="Page 5" docKey="current_menu_page5" />
//                 <FileUploadField label="Page 6" docKey="current_menu_page6" />
//                 <FileUploadField label="Page 7" docKey="current_menu_page7" />
//                 <FileUploadField label="Page 8" docKey="current_menu_page8" />
//                 <FileUploadField label="Page 9" docKey="current_menu_page9" />
//               </div>
//             </div>
//           </>
//         );

//       case "meta":
//         return (
//           <>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Subject</label>
//               <input style={styles.input} name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject" />
//             </div>
//             <div style={styles.inputGroup}>
//               <label style={styles.label}>Details</label>
//               <textarea style={styles.textarea} name="details" value={formData.details || ""} onChange={handleChange} placeholder="Additional details" />
//             </div>
//             <div style={{ marginTop: "20px" }}>
//               <div style={styles.infoRow}>
//                 <div style={styles.infoLabel}>Created By ID</div>
//                 <div style={styles.infoValue}>
//                   <input style={styles.input} name="created_by_id" placeholder="Admin ID" value={formData.created_by_id} onChange={handleChange} />
//                 </div>
//               </div>
//             </div>
//           </>
//         );

//       default:
//         return null;
//     }
//   };

//   // ── Navigation buttons ──
//   const goToNext = () => {
//     const currentIndex = sections.findIndex((s) => s.id === activeSection);
//     if (currentIndex < sections.length - 1) {
//       setActiveSection(sections[currentIndex + 1].id);
//     }
//   };

//   const goToPrev = () => {
//     const currentIndex = sections.findIndex((s) => s.id === activeSection);
//     if (currentIndex > 0) {
//       setActiveSection(sections[currentIndex - 1].id);
//     }
//   };

//   const currentIndex = sections.findIndex((s) => s.id === activeSection);
//   const isLastSection = currentIndex === sections.length - 1;
//   const isFirstSection = currentIndex === 0;

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <button style={styles.backBtn} onClick={handleCancel}>
//           <BackIcon /> Back
//         </button>
//         <h2 style={styles.headerTitle}>{isEditMode ? "Edit Restaurant" : "Add New Restaurant"}</h2>
//       </div>

//       <div style={styles.progressContainer}>
//         <div style={styles.progressHeader}>
//           <span style={styles.progressLabel}>Form Completion</span>
//           <span style={styles.progressPercent}>{Math.round(progressPercentage)}%</span>
//         </div>
//         <div style={styles.progressBarBg}>
//           <div style={styles.progressBarFill} />
//         </div>
//       </div>

//       <div style={styles.sectionButtons}>
//         {sections.map((section) => (
//           <button
//             key={section.id}
//             style={styles.sectionBtn(activeSection === section.id, filledSections[section.id])}
//             onClick={() => setActiveSection(section.id)}
//           >
//             <span>{section.icon}</span>
//             <span>{section.label}</span>
//             {filledSections[section.id] && <CheckCircleIcon />}
//           </button>
//         ))}
//       </div>

//       <div style={styles.formContainer}>
//         <div style={styles.formCard}>
//           <div style={styles.formTitle}>{sections.find((s) => s.id === activeSection)?.label}</div>

//           <form onSubmit={handleSubmit}>
//             {renderForm()}

//             <div style={styles.navButtons}>
//               <button
//                 type="button"
//                 style={styles.navBtn}
//                 onClick={goToPrev}
//                 disabled={isFirstSection}
//               >
//                 ← Previous
//               </button>
//               {!isLastSection ? (
//                 <button type="button" style={styles.navBtnPrimary} onClick={goToNext}>
//                   Next →
//                 </button>
//               ) : (
//                 <button type="submit" style={styles.navBtnPrimary} disabled={loading}>
//                   {loading ? "Saving..." : isEditMode ? "Update Restaurant" : "Create Restaurant"}
//                 </button>
//               )}
//             </div>
//           </form>
//         </div>
//       </div>

//       <div style={styles.fixedButtons}>
//         <button style={styles.cancelBtn} onClick={handleCancel}>
//           Cancel
//         </button>
//         <button style={styles.createBtn} onClick={handleSubmit} disabled={loading}>
//           {loading ? "Saving..." : isEditMode ? "Update" : "Create"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AddNewRestaurant;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { postData, putData, serverURL, getData } from "../../../../Services/Fetchnodeservices";

// ─── Helper: Convert "10:00 AM" → "10:00", "10:00 PM" → "22:00" ───
const convertTo24Hour = (timeStr) => {
  if (!timeStr) return "";
  const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
  if (match) {
    let hours = parseInt(match[1]);
    const minutes = match[2];
    const ampm = match[3].toUpperCase();
    if (ampm === "PM" && hours !== 12) hours += 12;
    if (ampm === "AM" && hours === 12) hours = 0;
    return `${String(hours).padStart(2, "0")}:${minutes}`;
  }
  if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr;
  return "";
};

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 3v12m0 0-3-3m3 3 3-3M5 21h14" />
    <rect x="3" y="15" width="18" height="5" rx="1" />
  </svg>
);

const BackIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const AddNewRestaurant = ({ isDark = true, onBack }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [activeSection, setActiveSection] = useState("personalInfo");

  const [formData, setFormData] = useState({
    old_id: "",
    name: "",
    organisation_name: "",
    org_type: "",
    pre: "",
    gender: "",
    contact: "",
    email: "",
    password: "",
    location: "",
    city: "",
    state: "",
    postal: "",
    address: "",
    latitude: "",
    longitude: "",
    owner_name: "",
    owner_mobile: "",
    other_person_name: "",
    other_person_mobile: "",
    bank_name: "",
    bank_branch: "",
    bank_type: "",
    account_holder: "",
    account_number: "",
    ifsc: "",
    bank_mobile: "",
    upi: "",
    comission: "",
    special_comission: "",
    min_order: "",
    platform_charge: "",
    handling_charge: "",
    gst_percentage: "",
    order_receiving_charges: "",
    subscription_id: "",
    paid: "",
    wallet: "",
    myreferal: "",
    refer_by: "",
    is_mou: "",
    status: "",
    hide: "",
    open_status: "",
    is_ready: "",
    shift_start: "",
    shift_end: "",
    is_auto_schedule: "",
    is_schedule_approved: "",
    is_verify_personalinfo: "",
    is_verify_docinfo: "",
    is_verify_bankinfo: "",
    remarks_personalinfo: "",
    remarks_docinfo: "",
    remarks_bankinfo: "",
    is_menu: "",
    isKOT: "",
    isBill: "",
    menu_direction: "neutral",
    menu_direction_type: "percentage",
    menu_direction_value: "",
    details: "",
    subject: "",
    meet_to: "",
    interestedin: "",
    gst_number: "",
    food_license_number: "",
    created_by_id: "1",
    is_approved: "",
    doc_verification: {
      aadhaar: { status: 0, remarks: "" },
      pan: { status: 0, remarks: "" },
      gst: { status: 0, remarks: "" },
      fssai: { status: 0, remarks: "" },
    },
  });

  const [documents, setDocuments] = useState({
    pic: null,
    pic_existing: "",
    r_logo: null,
    r_logo_existing: "",
    h_logo: null,
    h_logo_existing: "",
    aadhar_front: null,
    aadhar_front_existing: "",
    aadhar_back: null,
    aadhar_back_existing: "",
    pan_card: null,
    pan_card_existing: "",
    gst_pic: null,
    gst_pic_existing: "",
    food_license_pic: null,
    food_license_pic_existing: "",
    bank_pass: null,
    bank_pass_existing: "",
    cancel_cheque: null,
    cancel_cheque_existing: "",
    current_menu_page1: null,
    current_menu_page1_existing: "",
    current_menu_page2: null,
    current_menu_page2_existing: "",
    current_menu_page3: null,
    current_menu_page3_existing: "",
    current_menu_page4: null,
    current_menu_page4_existing: "",
    current_menu_page5: null,
    current_menu_page5_existing: "",
    current_menu_page6: null,
    current_menu_page6_existing: "",
    current_menu_page7: null,
    current_menu_page7_existing: "",
    current_menu_page8: null,
    current_menu_page8_existing: "",
    current_menu_page9: null,
    current_menu_page9_existing: "",
  });

  const [filledSections, setFilledSections] = useState({
    personalInfo: false,
    ownerDetails: false,
    bankDetails: false,
    businessSettings: false,
    statusSchedule: false,
    verification: false,
    documents: false,
    menu: false,
    meta: false,
  });

  const sections = [
    { id: "personalInfo", label: "Personal Info", icon: "👤" },
    { id: "ownerDetails", label: "Owner Details", icon: "👥" },
    { id: "bankDetails", label: "Bank Details", icon: "🏦" },
    { id: "businessSettings", label: "Business Settings", icon: "⚙️" },
    { id: "statusSchedule", label: "Status & Schedule", icon: "📅" },
    { id: "verification", label: "Verification", icon: "✅" },
    { id: "documents", label: "Documents", icon: "📄" },
    { id: "menu", label: "Menu", icon: "🍽️" },
    { id: "meta", label: "Meta", icon: "ℹ️" },
  ];

  // ── Load edit data ──
  useEffect(() => {
    const loadEditData = async () => {
      if (location.state?.mode === "edit" && location.state?.restaurantData) {
        const restaurant = location.state.restaurantData;
        setIsEditMode(true);
        setEditId(restaurant.id);

        try {
          const response = await getData(`restaurant/Restrunts/${restaurant.id}`);
          if (response.status && response.data) {
            const freshData = response.data;
            Object.assign(restaurant, freshData);
            console.log("✅ Fresh restaurant data:", restaurant);
          }
        } catch (error) {
          console.warn("Could not fetch fresh data, using passed data", error);
        }

        // Parse doc_verification
        let docVer = {};
        try {
          docVer = restaurant.doc_verification ? JSON.parse(restaurant.doc_verification) : {};
        } catch (e) {}
        const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
        docTypes.forEach(doc => {
          if (!docVer[doc]) docVer[doc] = { status: 0, remarks: "" };
          if (docVer[doc].status === undefined) docVer[doc].status = 0;
          if (docVer[doc].remarks === undefined) docVer[doc].remarks = "";
        });

        const docInfoVal = restaurant.is_verify_docinfo !== undefined ? Number(restaurant.is_verify_docinfo) : 0;
        if (docInfoVal === 1) {
          docTypes.forEach(doc => {
            if (docVer[doc]) docVer[doc].status = 1;
          });
        }

        // ── Ensure status fields are strings ──
        const toStr = (val) => (val !== undefined && val !== null) ? String(val) : "";

        const shiftStart24 = convertTo24Hour(restaurant.shift_start);
        const shiftEnd24 = convertTo24Hour(restaurant.shift_end);

        // setFormData({
        //   old_id: restaurant.old_id || restaurant.id || "",
        //   name: restaurant.name || "",
        //   organisation_name: restaurant.organisation_name || "",
        //   org_type: restaurant.org_type || "",
        //   pre: restaurant.pre || "",
        //   gender: restaurant.gender || "",
        //   contact: restaurant.contact || "",
        //   email: restaurant.email || "",
        //   password: "",
        //   location: restaurant.location || "",
        //   city: restaurant.city || "",
        //   state: restaurant.state || "",
        //   postal: restaurant.postal || "",
        //   address: restaurant.address || "",
        //   latitude: restaurant.latitude || "",
        //   longitude: restaurant.longitude || "",
        //   owner_name: restaurant.owner_name || "",
        //   owner_mobile: restaurant.owner_mobile || "",
        //   other_person_name: restaurant.other_person_name || "",
        //   other_person_mobile: restaurant.other_person_mobile || "",
        //   bank_name: restaurant.bank_name || "",
        //   bank_branch: restaurant.bank_branch || "",
        //   bank_type: restaurant.bank_type || "",
        //   account_holder: restaurant.account_holder || "",
        //   account_number: restaurant.account_number || "",
        //   ifsc: restaurant.ifsc || "",
        //   bank_mobile: restaurant.bank_mobile || "",
        //   upi: restaurant.upi || "",
        //   comission: restaurant.comission || "",
        //   special_comission: restaurant.special_comission || "",
        //   min_order: restaurant.min_order || "",
        //   platform_charge: restaurant.platform_charge || "",
        //   handling_charge: restaurant.handling_charge || "",
        //   gst_percentage: restaurant.gst_percentage || "",
        //   order_receiving_charges: restaurant.order_receiving_charges || "",
        //   subscription_id: restaurant.subscription_id || "",
        //   paid: toStr(restaurant.paid),
        //   wallet: restaurant.wallet || "0",
        //   myreferal: restaurant.myreferal || "",
        //   refer_by: restaurant.refer_by || "",
        //   is_mou: toStr(restaurant.is_mou),
        //   status: toStr(restaurant.status),
        //   hide: toStr(restaurant.hide),
        //   open_status: toStr(restaurant.open_status),
        //   is_ready: toStr(restaurant.is_ready),
        //   shift_start: shiftStart24,
        //   shift_end: shiftEnd24,
        //   is_auto_schedule: toStr(restaurant.is_auto_schedule),
        //   is_schedule_approved: toStr(restaurant.is_schedule_approved),
        //   is_verify_personalinfo: toStr(restaurant.is_verify_personalinfo),
        //   is_verify_docinfo: toStr(restaurant.is_verify_docinfo),
        //   is_verify_bankinfo: toStr(restaurant.is_verify_bankinfo),
        //   remarks_personalinfo: restaurant.remarks_personalinfo || "",
        //   remarks_docinfo: restaurant.remarks_docinfo || "",
        //   remarks_bankinfo: restaurant.remarks_bankinfo || "",
        //   is_menu: toStr(restaurant.is_menu),
        //   isKOT: toStr(restaurant.isKOT),
        //   isBill: toStr(restaurant.isBill),
        //   menu_direction: restaurant.menu_direction || "neutral",
        //   menu_direction_type: restaurant.menu_direction_type || "percentage",
        //   menu_direction_value: restaurant.menu_direction_value || "",
        //   details: restaurant.details || "",
        //   subject: restaurant.subject || "",
        //   meet_to: restaurant.meet_to || "",
        //   interestedin: restaurant.interestedin || "",
        //   gst_number: restaurant.gst_number || "",
        //   food_license_number: restaurant.food_license_number || "",
        //   created_by_id: restaurant.created_by_id || "1",
        //   is_approved: toStr(restaurant.is_approved),
        //   doc_verification: docVer,
        // });

        setFormData({
  old_id: restaurant.old_id || restaurant.id || "",
  name: restaurant.name || "",
  organisation_name: restaurant.organisation_name || "",
  org_type: restaurant.org_type || "",
  pre: restaurant.pre || "",
  gender: restaurant.gender || "",
  contact: restaurant.contact || "",
  email: restaurant.email || "",
  password: "",
  location: restaurant.location || "",
  city: restaurant.city || "",
  state: restaurant.state || "",
  postal: restaurant.postal || "",
  address: restaurant.address || "",
  latitude: restaurant.latitude || "",
  longitude: restaurant.longitude || "",

  // ✅ OWNER DETAILS – fallback to restaurant name/contact if empty
  owner_name: restaurant.owner_name || restaurant.name || "",
  owner_mobile: restaurant.owner_mobile || restaurant.contact || "",
  other_person_name: restaurant.other_person_name || "",
  other_person_mobile: restaurant.other_person_mobile || "",

  // Other fields
  bank_name: restaurant.bank_name || "",
  bank_branch: restaurant.bank_branch || "",
  bank_type: restaurant.bank_type || "",
  account_holder: restaurant.account_holder || "",
  account_number: restaurant.account_number || "",
  ifsc: restaurant.ifsc || "",
  bank_mobile: restaurant.bank_mobile || "",
  upi: restaurant.upi || "",
  comission: restaurant.comission || "",
  special_comission: restaurant.special_comission || "",
  min_order: restaurant.min_order || "",
  platform_charge: restaurant.platform_charge || "",
  handling_charge: restaurant.handling_charge || "",
  gst_percentage: restaurant.gst_percentage || "",
  order_receiving_charges: restaurant.order_receiving_charges || "",
  subscription_id: restaurant.subscription_id || "",
  paid: toStr(restaurant.paid),
  wallet: restaurant.wallet || "0",
  myreferal: restaurant.myreferal || "",
  refer_by: restaurant.refer_by || "",
  is_mou: toStr(restaurant.is_mou),
  status: toStr(restaurant.status),
  hide: toStr(restaurant.hide),
  open_status: toStr(restaurant.open_status),
  is_ready: toStr(restaurant.is_ready),
  shift_start: shiftStart24,
  shift_end: shiftEnd24,
  is_auto_schedule: toStr(restaurant.is_auto_schedule),
  is_schedule_approved: toStr(restaurant.is_schedule_approved),
  is_verify_personalinfo: toStr(restaurant.is_verify_personalinfo),
  is_verify_docinfo: toStr(restaurant.is_verify_docinfo),
  is_verify_bankinfo: toStr(restaurant.is_verify_bankinfo),
  remarks_personalinfo: restaurant.remarks_personalinfo || "",
  remarks_docinfo: restaurant.remarks_docinfo || "",
  remarks_bankinfo: restaurant.remarks_bankinfo || "",
  is_menu: toStr(restaurant.is_menu),
  isKOT: toStr(restaurant.isKOT),
  isBill: toStr(restaurant.isBill),
  menu_direction: restaurant.menu_direction || "neutral",
  menu_direction_type: restaurant.menu_direction_type || "percentage",
  menu_direction_value: restaurant.menu_direction_value || "",
  details: restaurant.details || "",
  subject: restaurant.subject || "",
  meet_to: restaurant.meet_to || "",
  interestedin: restaurant.interestedin || "",
  gst_number: restaurant.gst_number || "",
  food_license_number: restaurant.food_license_number || "",
  created_by_id: restaurant.created_by_id || "1",
  is_approved: toStr(restaurant.is_approved),
  doc_verification: docVer,
});

        setDocuments((prev) => ({
          ...prev,
          pic_existing: restaurant.pic || "",
          h_logo_existing: restaurant.h_logo || "",
          r_logo_existing: restaurant.r_logo || "",
          aadhar_front_existing: restaurant.aadhar_front || "",
          aadhar_back_existing: restaurant.aadhar_back || "",
          pan_card_existing: restaurant.pan_card || "",
          gst_pic_existing: restaurant.gst_pic || "",
          food_license_pic_existing: restaurant.food_license_pic || "",
          bank_pass_existing: restaurant.bank_pass || "",
          cancel_cheque_existing: restaurant.cancel_cheque || "",
          current_menu_page1_existing: restaurant.current_menu_page1 || "",
          current_menu_page2_existing: restaurant.current_menu_page2 || "",
          current_menu_page3_existing: restaurant.current_menu_page3 || "",
          current_menu_page4_existing: restaurant.current_menu_page4 || "",
          current_menu_page5_existing: restaurant.current_menu_page5 || "",
          current_menu_page6_existing: restaurant.current_menu_page6 || "",
          current_menu_page7_existing: restaurant.current_menu_page7 || "",
          current_menu_page8_existing: restaurant.current_menu_page8 || "",
          current_menu_page9_existing: restaurant.current_menu_page9 || "",
        }));

        const allFilled = {};
        Object.keys(filledSections).forEach((key) => {
          allFilled[key] = true;
        });
        setFilledSections(allFilled);
      }
    };
    loadEditData();
  }, [location.state]);

  // ── Auto‑sync: when doc_verification changes, recompute is_verify_docinfo ──
  useEffect(() => {
    const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
    const allVerified = docTypes.every(doc => formData.doc_verification[doc]?.status === 1);
    const newDocInfo = allVerified ? 1 : 0;
    if (Number(formData.is_verify_docinfo) !== newDocInfo) {
      setFormData(prev => ({
        ...prev,
        is_verify_docinfo: newDocInfo.toString()
      }));
    }
  }, [formData.doc_verification]);

  // ── Handlers ──
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("doc_verification.")) {
      const parts = name.split(".");
      const docType = parts[1];
      const field = parts[2];
      setFormData((prev) => ({
        ...prev,
        doc_verification: {
          ...prev.doc_verification,
          [docType]: {
            ...prev.doc_verification[docType],
            [field]: field === "status" ? parseInt(value) : value,
          },
        },
      }));
      return;
    }

    if (name === "is_verify_docinfo") {
      const docInfoVal = parseInt(value) || 0;
      const newDocVer = { ...formData.doc_verification };
      const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
      docTypes.forEach(doc => {
        if (newDocVer[doc]) {
          newDocVer[doc].status = docInfoVal;
        }
      });
      setFormData({
        ...formData,
        [name]: value,
        doc_verification: newDocVer,
      });
      return;
    }

    setFormData({ ...formData, [name]: value });
    checkSectionFilled(activeSection, { ...formData, [name]: value });
  };

  const handleFileUpload = (docName, file) => {
    setDocuments({ ...documents, [docName]: file });
  };

  const checkSectionFilled = (section, data) => {
    let isFilled = false;
    switch (section) {
      case "personalInfo":
        isFilled = !!data.name || !!data.contact || !!data.email;
        break;
      case "ownerDetails":
        isFilled = !!data.owner_name || !!data.owner_mobile;
        break;
      case "bankDetails":
        isFilled = !!data.bank_name || !!data.account_number || !!data.ifsc;
        break;
      case "businessSettings":
        isFilled = !!data.comission || !!data.min_order;
        break;
      case "statusSchedule":
        isFilled = !!data.status;
        break;
      case "verification":
        isFilled =
          !!data.is_verify_personalinfo ||
          !!data.is_verify_docinfo ||
          !!data.is_verify_bankinfo ||
          data.is_approved !== "";
        break;
      case "documents":
        const hasDoc = Object.keys(documents).some((key) => {
          if (key.includes("_existing")) return false;
          return documents[key] !== null && documents[key] !== "";
        });
        isFilled = hasDoc;
        break;
      case "menu":
        isFilled = !!data.is_menu;
        break;
      case "meta":
        isFilled = !!data.details;
        break;
      default:
        isFilled = false;
    }
    setFilledSections((prev) => ({ ...prev, [section]: isFilled }));
  };

  const completedCount = Object.values(filledSections).filter((v) => v === true).length;
  const progressPercentage = (completedCount / sections.length) * 100;

  // ── Submit ──
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();

      const docTypes = ['aadhaar', 'pan', 'gst', 'fssai'];
      let docVer = { ...formData.doc_verification };
      docTypes.forEach(doc => {
        if (!docVer[doc]) docVer[doc] = { status: 0, remarks: "" };
        if (docVer[doc].status === undefined || docVer[doc].status === null) {
          docVer[doc].status = 0;
        }
        if (docVer[doc].remarks === undefined) {
          docVer[doc].remarks = "";
        }
      });

      Object.keys(formData).forEach((key) => {
        if (key === "password" && !formData[key] && isEditMode) {
          return;
        }
        if (key === "doc_verification") {
          data.append(key, JSON.stringify(docVer));
        } else {
          data.append(key, formData[key] || "");
        }
      });

      const fileFields = [
        "pic", "r_logo", "h_logo", "aadhar_front", "aadhar_back",
        "pan_card", "gst_pic", "food_license_pic", "bank_pass", "cancel_cheque",
        "current_menu_page1", "current_menu_page2", "current_menu_page3",
        "current_menu_page4", "current_menu_page5", "current_menu_page6",
        "current_menu_page7", "current_menu_page8", "current_menu_page9",
      ];

      fileFields.forEach((field) => {
        if (documents[field] && documents[field] instanceof File) {
          data.append(field, documents[field]);
        }
      });

      let response;
      if (isEditMode && editId) {
        data.append("id", editId);
        response = await postData(`restaurant/updaterestaurant/${editId}`, data);
      } else {
        response = await postData("resturant/addrestaurant", data);
      }

      if (response.status || response.data?.status) {
        alert(isEditMode ? "Restaurant Updated Successfully" : "Restaurant Added Successfully");
        if (onBack) onBack();
        else navigate("/Dashboard/restaurants");
      } else {
        alert(response.data?.message || response.message || "Failed to save restaurant");
      }
    } catch (error) {
      console.log(error);
      alert(error?.response?.data?.message || error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (onBack) onBack();
    else navigate("/Dashboard/restaurants");
  };

  // ── Styles (same as before, no changes) ──
  const styles = {
    container: {
      background: isDark ? "#0d1117" : "#f8fafc",
      fontFamily: "'Segoe UI', 'DM Sans', sans-serif",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
    },
    header: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      padding: "16px 24px",
      borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isDark ? "#0d1117" : "#f8fafc",
      position: "sticky",
      top: 0,
      zIndex: 10,
    },
    backBtn: {
      background: "none",
      border: "none",
      cursor: "pointer",
      color: isDark ? "#94a3b8" : "#64748b",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "14px",
      padding: "8px 12px",
      borderRadius: "8px",
    },
    headerTitle: {
      fontSize: "20px",
      fontWeight: 700,
      color: isDark ? "#f1f5f9" : "#1e293b",
      margin: 0,
      flex: 1,
    },
    progressContainer: {
      padding: "12px 24px",
      background: isDark ? "#0d1117" : "#f8fafc",
      borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    },
    progressHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
    },
    progressLabel: {
      fontSize: "12px",
      fontWeight: 600,
      color: isDark ? "#64748b" : "#475569",
    },
    progressPercent: {
      fontSize: "12px",
      fontWeight: 700,
      color: "#4a6cf7",
    },
    progressBarBg: {
      background: isDark ? "#1e2740" : "#e2e8f0",
      borderRadius: "10px",
      height: "6px",
      overflow: "hidden",
    },
    progressBarFill: {
      background: "linear-gradient(90deg, #4a6cf7, #8b5cf6)",
      width: `${progressPercentage}%`,
      height: "100%",
      borderRadius: "10px",
      transition: "width 0.3s ease",
    },
    sectionButtons: {
      display: "flex",
      gap: "8px",
      padding: "16px 24px",
      overflowX: "auto",
      background: isDark ? "#0d1117" : "#f8fafc",
      borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      scrollbarWidth: "thin",
    },
    sectionBtn: (isActive, isCompleted) => ({
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 16px",
      borderRadius: "10px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.2s",
      background: isActive
        ? "#4a6cf7"
        : isDark
        ? "#141824"
        : "#ffffff",
      border: isActive
        ? "1px solid #4a6cf7"
        : isDark
        ? "1px solid #1e2740"
        : "1px solid #e2e8f0",
      color: isActive
        ? "#ffffff"
        : isDark
        ? "#94a3b8"
        : "#64748b",
      whiteSpace: "nowrap",
    }),
    formContainer: {
      flex: 1,
      overflowY: "auto",
      padding: "24px",
    },
    formCard: {
      background: isDark ? "#141824" : "#ffffff",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "16px",
      padding: "24px",
    },
    formTitle: {
      fontSize: "18px",
      fontWeight: 700,
      color: isDark ? "#f1f5f9" : "#1e293b",
      marginBottom: "20px",
      paddingBottom: "12px",
      borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    },
    formGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "20px",
    },
    formGrid3: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "16px",
    },
    inputGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
    },
    label: {
      fontSize: "12px",
      fontWeight: 600,
      color: isDark ? "#64748b" : "#475569",
      letterSpacing: "0.3px",
    },
    input: {
      padding: "10px 14px",
      background: isDark ? "#0f1520" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "8px",
      fontSize: "13px",
      color: isDark ? "#e2e8f0" : "#1e293b",
      outline: "none",
      transition: "all 0.2s",
    },
    select: {
      padding: "10px 14px",
      background: isDark ? "#0f1520" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "8px",
      fontSize: "13px",
      color: isDark ? "#e2e8f0" : "#1e293b",
      outline: "none",
      cursor: "pointer",
    },
    textarea: {
      padding: "10px 14px",
      background: isDark ? "#0f1520" : "#f8fafc",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "8px",
      fontSize: "13px",
      color: isDark ? "#e2e8f0" : "#1e293b",
      outline: "none",
      fontFamily: "inherit",
      resize: "vertical",
      minHeight: "80px",
    },
    documentGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
      gap: "16px",
    },
    uploadBox: {
      border: isDark ? "1px dashed #1e2740" : "1px dashed #cbd5e1",
      borderRadius: "12px",
      padding: "16px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.2s",
      background: isDark ? "#0f1520" : "#f8fafc",
      position: "relative",
    },
    uploadLabel: {
      fontSize: "12px",
      color: isDark ? "#64748b" : "#94a3b8",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
      cursor: "pointer",
    },
    existingImage: {
      maxWidth: "100%",
      maxHeight: "80px",
      borderRadius: "4px",
      objectFit: "cover",
      marginTop: "8px",
    },
    removeBtn: {
      position: "absolute",
      top: "4px",
      right: "4px",
      background: "#ef4444",
      border: "none",
      borderRadius: "50%",
      width: "22px",
      height: "22px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#fff",
      fontSize: "12px",
    },
    fixedButtons: {
      position: "sticky",
      bottom: 0,
      padding: "16px 24px",
      background: isDark ? "#0d1117" : "#f8fafc",
      borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      display: "flex",
      justifyContent: "flex-end",
      gap: "12px",
      zIndex: 10,
    },
    cancelBtn: {
      padding: "10px 24px",
      background: "transparent",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: 600,
      color: isDark ? "#94a3b8" : "#64748b",
      cursor: "pointer",
    },
    createBtn: {
      padding: "10px 24px",
      background: "#4a6cf7",
      border: "none",
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: 600,
      color: "#fff",
      cursor: "pointer",
    },
    infoRow: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
      padding: "12px 0",
      borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    },
    infoLabel: {
      fontSize: "12px",
      fontWeight: 600,
      color: isDark ? "#64748b" : "#475569",
      width: "120px",
    },
    infoValue: {
      fontSize: "13px",
      color: isDark ? "#e2e8f0" : "#1e293b",
      flex: 1,
    },
    navButtons: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "24px",
      paddingTop: "20px",
      borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
    },
    navBtn: {
      padding: "8px 20px",
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
      background: isDark ? "#0f1520" : "#f8fafc",
      color: isDark ? "#94a3b8" : "#64748b",
    },
    navBtnPrimary: {
      padding: "8px 20px",
      borderRadius: "8px",
      fontSize: "13px",
      fontWeight: 600,
      cursor: "pointer",
      background: "#4a6cf7",
      border: "none",
      color: "#fff",
    },
    infoBox: {
      background: isDark ? "#0f1520" : "#f0fdf4",
      border: `1px solid ${isDark ? "#1e2740" : "#bbf7d0"}`,
      borderRadius: "12px",
      padding: "16px",
      marginBottom: "20px",
    },
    infoTitle: {
      fontSize: "13px",
      fontWeight: 600,
      color: isDark ? "#f1f5f9" : "#166534",
      marginBottom: "8px",
    },
    infoDesc: {
      fontSize: "12px",
      color: isDark ? "#94a3b8" : "#15803d",
    },
  };

  // ── Helper: Get image URL ──
  const getImageUrl = (filename) => {
    if (!filename) return null;
    if (filename.startsWith("http")) return filename;
    if (filename.startsWith("blob:")) return filename;
    // ✅ Fixed: use /uploads/ (as served by app.js)
    return `${serverURL}/uploads/${filename}`;
  };

  // ── File Upload Field ──
  const FileUploadField = ({ label, docKey }) => {
    const file = documents[docKey];
    const existingFile = documents[`${docKey}_existing`];
    const hasFile = file instanceof File || (existingFile && existingFile !== "");

    let imageUrl = null;
    if (file instanceof File) {
      imageUrl = URL.createObjectURL(file);
    } else if (existingFile) {
      imageUrl = getImageUrl(existingFile);
    }

    return (
      <div style={styles.uploadBox}>
        <label style={styles.uploadLabel}>
          <input
            type="file"
            style={{ display: "none" }}
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                handleFileUpload(docKey, e.target.files[0]);
              }
            }}
          />
          <UploadIcon />
          <span style={{ fontSize: "11px", wordBreak: "break-all" }}>
            {file instanceof File ? file.name : existingFile ? existingFile : label}
          </span>
        </label>
        {imageUrl && (
          <div style={{ marginTop: "8px" }}>
            <img src={imageUrl} alt={label} style={styles.existingImage} />
          </div>
        )}
        {hasFile && (
          <button
            style={styles.removeBtn}
            onClick={(e) => {
              e.stopPropagation();
              setDocuments((prev) => ({ ...prev, [docKey]: null }));
            }}
            type="button"
          >
            ✕
          </button>
        )}
      </div>
    );
  };

  // ── Render each section ──
  const renderForm = () => {
    switch (activeSection) {
      case "personalInfo":
        return (
          <div style={styles.formGrid}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Old ID</label>
              <input style={styles.input} name="old_id" value={formData.old_id} onChange={handleChange} placeholder="Old ID" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Restaurant Name *</label>
              <input style={styles.input} name="name" value={formData.name} onChange={handleChange} placeholder="Enter restaurant name" required />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Organisation Name</label>
              <input style={styles.input} name="organisation_name" value={formData.organisation_name} onChange={handleChange} placeholder="Organisation name" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Org Type</label>
              <select style={styles.select} name="org_type" value={formData.org_type} onChange={handleChange}>
                <option value="">Select</option>
                <option value="0">Individual</option>
                <option value="1">Partnership</option>
                <option value="2">Company</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Prefix</label>
              <select style={styles.select} name="pre" value={formData.pre} onChange={handleChange}>
                <option value="">Select</option>
                <option value="Mr.">Mr.</option>
                <option value="Ms.">Ms.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Dr.">Dr.</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Gender</label>
              <select style={styles.select} name="gender" value={formData.gender} onChange={handleChange}>
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Contact Number *</label>
              <input style={styles.input} name="contact" value={formData.contact} onChange={handleChange} placeholder="+91 98765 43210" required />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Email *</label>
              <input style={styles.input} name="email" type="email" value={formData.email} onChange={handleChange} placeholder="restaurant@example.com" required />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Password {!isEditMode && "*"}</label>
              <input style={styles.input} name="password" type="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required={!isEditMode} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>City</label>
              <input style={styles.input} name="city" value={formData.city} onChange={handleChange} placeholder="Enter city" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>State</label>
              <input style={styles.input} name="state" value={formData.state} onChange={handleChange} placeholder="Enter state" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>PIN Code</label>
              <input style={styles.input} name="postal" value={formData.postal} onChange={handleChange} placeholder="6-digit PIN" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Address</label>
              <textarea style={styles.textarea} name="address" value={formData.address} onChange={handleChange} placeholder="Full address" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Latitude</label>
              <input style={styles.input} name="latitude" value={formData.latitude} onChange={handleChange} placeholder="Latitude" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Longitude</label>
              <input style={styles.input} name="longitude" value={formData.longitude} onChange={handleChange} placeholder="Longitude" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Round Logo</label>
              <FileUploadField label="Upload Round Logo" docKey="pic" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Horizontal Logo</label>
              <FileUploadField label="Upload Horizontal Logo" docKey="h_logo" />
            </div>
          </div>
        );

      case "ownerDetails":
        return (
          <div style={styles.formGrid}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Owner Name</label>
              <input style={styles.input} name="owner_name" value={formData.owner_name} onChange={handleChange} placeholder="Full name" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Owner Mobile</label>
              <input style={styles.input} name="owner_mobile" value={formData.owner_mobile} onChange={handleChange} placeholder="+91 XXXXX XXXXX" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Other Person Name</label>
              <input style={styles.input} name="other_person_name" value={formData.other_person_name} onChange={handleChange} placeholder="Optional" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Other Person Mobile</label>
              <input style={styles.input} name="other_person_mobile" value={formData.other_person_mobile} onChange={handleChange} placeholder="Optional" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Meet To</label>
              <input style={styles.input} name="meet_to" value={formData.meet_to || ""} onChange={handleChange} placeholder="Meet To" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Interested In</label>
              <input style={styles.input} name="interestedin" value={formData.interestedin || ""} onChange={handleChange} placeholder="Interested In" />
            </div>
          </div>
        );

      case "bankDetails":
        return (
          <>
            <div style={styles.formGrid}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Bank Name</label>
                <input style={styles.input} name="bank_name" value={formData.bank_name} onChange={handleChange} placeholder="Bank name" />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Branch</label>
                <input style={styles.input} name="bank_branch" value={formData.bank_branch} onChange={handleChange} placeholder="Branch name" />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Bank Type</label>
                <select style={styles.select} name="bank_type" value={formData.bank_type} onChange={handleChange}>
                  <option value="">Select</option>
                  <option value="Savings">Savings</option>
                  <option value="Current">Current</option>
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Account Holder</label>
                <input style={styles.input} name="account_holder" value={formData.account_holder} onChange={handleChange} placeholder="Account holder name" />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Account Number</label>
                <input style={styles.input} name="account_number" value={formData.account_number} onChange={handleChange} placeholder="Account number" />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>IFSC Code</label>
                <input style={styles.input} name="ifsc" value={formData.ifsc} onChange={handleChange} placeholder="IFSC code" />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Bank Mobile</label>
                <input style={styles.input} name="bank_mobile" value={formData.bank_mobile} onChange={handleChange} placeholder="Registered mobile" />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>UPI</label>
                <input style={styles.input} name="upi" value={formData.upi || ""} onChange={handleChange} placeholder="UPI ID" />
              </div>
            </div>
            <div style={{ marginTop: "16px", display: "flex", justifyContent: "space-evenly", flexWrap: "wrap", gap: "10px" }}>
              <FileUploadField label="Bank Passbook" docKey="bank_pass" />
              <FileUploadField label="Cancel Cheque" docKey="cancel_cheque" />
            </div>
          </>
        );

      case "businessSettings":
        return (
          <div style={styles.formGrid}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Commission (%)</label>
              <input style={styles.input} name="comission" value={formData.comission} onChange={handleChange} placeholder="e.g., 10" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Special Commission (%)</label>
              <input style={styles.input} name="special_comission" value={formData.special_comission} onChange={handleChange} placeholder="e.g., 5" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Minimum Order (₹)</label>
              <input style={styles.input} name="min_order" value={formData.min_order} onChange={handleChange} placeholder="₹" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Platform Charge (₹)</label>
              <input style={styles.input} name="platform_charge" value={formData.platform_charge} onChange={handleChange} placeholder="₹" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Handling Charge (%)</label>
              <input style={styles.input} name="handling_charge" value={formData.handling_charge} onChange={handleChange} placeholder="%" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>GST (%)</label>
              <input style={styles.input} name="gst_percentage" value={formData.gst_percentage} onChange={handleChange} placeholder="%" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Order Receiving Charges (%)</label>
              <input style={styles.input} name="order_receiving_charges" value={formData.order_receiving_charges} onChange={handleChange} placeholder="%" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Subscription</label>
              <select style={styles.select} name="subscription_id" value={formData.subscription_id} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Basic</option>
                <option value="2">Premium</option>
                <option value="3">Enterprise</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Paid Status</label>
              <select style={styles.select} name="paid" value={formData.paid} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Paid</option>
                <option value="0">Unpaid</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Wallet (₹)</label>
              <input style={styles.input} name="wallet" value={formData.wallet} onChange={handleChange} placeholder="₹" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Referral Code</label>
              <input style={styles.input} name="myreferal" value={formData.myreferal} onChange={handleChange} placeholder="Referral code" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Referred By</label>
              <input style={styles.input} name="refer_by" value={formData.refer_by} onChange={handleChange} placeholder="Referrer" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>MOU Signed</label>
              <select style={styles.select} name="is_mou" value={formData.is_mou} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
        );

      case "statusSchedule":
        return (
          <div style={styles.formGrid}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Status</label>
              <select style={styles.select} name="status" value={formData.status} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Hide</label>
              <select style={styles.select} name="hide" value={formData.hide} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Schedule Mode</label>
              <select style={styles.select} name="is_auto_schedule" value={formData.is_auto_schedule} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Auto</option>
                <option value="0">Manual</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Shift Start</label>
              <input style={styles.input} name="shift_start" type="time" value={formData.shift_start} onChange={handleChange} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Shift End</label>
              <input style={styles.input} name="shift_end" type="time" value={formData.shift_end} onChange={handleChange} />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Open Status</label>
              <select style={styles.select} name="open_status" value={formData.open_status} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Open</option>
                <option value="0">Closed</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Schedule Approved</label>
              <select style={styles.select} name="is_schedule_approved" value={formData.is_schedule_approved} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Is Ready</label>
              <select style={styles.select} name="is_ready" value={formData.is_ready} onChange={handleChange}>
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          </div>
        );

      case "verification":
        return (
          <div style={styles.formGrid}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Personal Info Verified</label>
              <select style={styles.select} name="is_verify_personalinfo" value={formData.is_verify_personalinfo} onChange={handleChange}>
                <option value="">Select...</option>
                <option value="1">Verified</option>
                <option value="0">Pending</option>
                <option value="2">Rejected</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Remarks (Personal)</label>
              <input style={styles.input} name="remarks_personalinfo" value={formData.remarks_personalinfo} onChange={handleChange} placeholder="Remarks" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Bank Verified</label>
              <select style={styles.select} name="is_verify_bankinfo" value={formData.is_verify_bankinfo} onChange={handleChange}>
                <option value="">Select...</option>
                <option value="1">Verified</option>
                <option value="0">Pending</option>
                <option value="2">Rejected</option>
              </select>
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Remarks (Bank)</label>
              <input style={styles.input} name="remarks_bankinfo" value={formData.remarks_bankinfo} onChange={handleChange} placeholder="Remarks" />
            </div>

            <div style={{ gridColumn: "1 / -1", marginTop: "20px", borderTop: "1px solid " + (isDark ? "#1e2740" : "#e2e8f0"), paddingTop: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                <h4 style={{ fontSize: "14px", fontWeight: 700, color: isDark ? "#f1f5f9" : "#1e293b" }}>
                  Document-wise Verification
                </h4>
                <span style={{ fontSize: "12px", color: isDark ? "#94a3b8" : "#64748b" }}>
                  Overall Doc Status: {formData.is_verify_docinfo === "1" ? "✅ Verified" : "⏳ Pending"}
                </span>
              </div>
              {["aadhaar", "pan", "gst", "fssai"].map((doc) => {
                const docData = formData.doc_verification?.[doc] || { status: 0, remarks: "" };
                const statusMap = { 0: "Pending", 1: "Verified", 2: "Rejected" };
                return (
                  <div key={doc} style={{ ...styles.inputGroup, marginBottom: "16px" }}>
                    <label style={styles.label}>{doc.toUpperCase()}</label>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                      <select
                        style={{ ...styles.select, flex: 1, minWidth: "120px" }}
                        value={docData.status}
                        onChange={(e) => {
                          const newDocVer = { ...formData.doc_verification };
                          if (!newDocVer[doc]) newDocVer[doc] = {};
                          newDocVer[doc].status = parseInt(e.target.value);
                          setFormData({ ...formData, doc_verification: newDocVer });
                        }}
                      >
                        <option value="0">Pending</option>
                        <option value="1">Verified</option>
                        <option value="2">Rejected</option>
                      </select>
                      <input
                        style={{ ...styles.input, flex: 2 }}
                        placeholder="Remarks"
                        value={docData.remarks || ""}
                        onChange={(e) => {
                          const newDocVer = { ...formData.doc_verification };
                          if (!newDocVer[doc]) newDocVer[doc] = {};
                          newDocVer[doc].remarks = e.target.value;
                          setFormData({ ...formData, doc_verification: newDocVer });
                        }}
                      />
                      <span style={{ fontSize: "11px", color: isDark ? "#94a3b8" : "#64748b", minWidth: "70px" }}>
                        {statusMap[docData.status] || "Pending"}
                      </span>
                    </div>
                  </div>
                );
              })}
              <div style={{ fontSize: "12px", color: isDark ? "#94a3b8" : "#64748b", marginTop: "8px" }}>
                ⚠️ Changing the overall "Document Verified" dropdown will automatically set all individual doc statuses.
              </div>
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Approval Status</label>
              <select style={styles.select} name="is_approved" value={formData.is_approved} onChange={handleChange}>
                <option value="">Select...</option>
                <option value="0">Pending</option>
                <option value="1">Approved</option>
              </select>
              <small style={{ color: isDark ? "#94a3b8" : "#64748b", fontSize: "11px" }}>
                {formData.is_approved === "1"
                  ? "✅ Approved – vendor can log in"
                  : formData.is_approved === "0"
                  ? "⏳ Pending approval"
                  : "Not set"}
              </small>
            </div>
          </div>
        );

      case "documents":
        return (
          <div style={styles.documentGrid}>
            <FileUploadField label="Aadhar Front" docKey="aadhar_front" />
            <FileUploadField label="Aadhar Back" docKey="aadhar_back" />
            <FileUploadField label="Pan Card" docKey="pan_card" />
            <FileUploadField label="GST Image" docKey="gst_pic" />
            <FileUploadField label="Food License" docKey="food_license_pic" />
            <div style={styles.inputGroup}>
              <label style={styles.label}>GST Number</label>
              <input type="text" style={styles.input} name="gst_number" value={formData.gst_number || ""} onChange={handleChange} placeholder="Enter GST Number" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Food License Number</label>
              <input type="text" style={styles.input} name="food_license_number" value={formData.food_license_number || ""} onChange={handleChange} placeholder="Enter Food License Number" />
            </div>
          </div>
        );

      case "menu":
        return (
          <>
            <div style={styles.formGrid3}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Menu Uploaded</label>
                <select style={styles.select} name="is_menu" value={formData.is_menu} onChange={handleChange}>
                  <option value="">Select...</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>KOT Enabled</label>
                <select style={styles.select} name="isKOT" value={formData.isKOT} onChange={handleChange}>
                  <option value="">Select...</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Bill Enabled</label>
                <select style={styles.select} name="isBill" value={formData.isBill} onChange={handleChange}>
                  <option value="">Select...</option>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </select>
              </div>
            </div>
            <div style={{ ...styles.infoBox, marginTop: "20px" }}>
              <div style={styles.infoTitle}>📊 Menu Price Adjustment</div>
              <div style={styles.infoDesc}>
                {formData.menu_direction === "neutral" && "No price adjustment applied."}
                {formData.menu_direction === "above" &&
                  `✓ ${formData.menu_direction_type === "fixed" ? `₹${formData.menu_direction_value || 0}` : `${formData.menu_direction_value || 0}%`} will be ADDED to all menu items.`}
                {formData.menu_direction === "below" &&
                  `✓ ${formData.menu_direction_type === "fixed" ? `₹${formData.menu_direction_value || 0}` : `${formData.menu_direction_value || 0}%`} will be DEDUCTED from all menu items.`}
              </div>
            </div>
            <div style={styles.formGrid}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Menu Direction</label>
                <select style={styles.select} name="menu_direction" value={formData.menu_direction} onChange={handleChange}>
                  <option value="neutral">Neutral (No Change)</option>
                  <option value="above">Above (Add)</option>
                  <option value="below">Below (Subtract)</option>
                </select>
              </div>
              {formData.menu_direction !== "neutral" && (
                <>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Direction Type</label>
                    <select style={styles.select} name="menu_direction_type" value={formData.menu_direction_type} onChange={handleChange}>
                      <option value="fixed">Fixed (₹)</option>
                      <option value="percentage">Percentage (%)</option>
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>
                      {formData.menu_direction_type === "fixed" ? "Value (₹)" : "Value (%)"}
                    </label>
                    <input
                      style={styles.input}
                      name="menu_direction_value"
                      value={formData.menu_direction_value}
                      onChange={handleChange}
                      type="number"
                      step={formData.menu_direction_type === "fixed" ? "1" : "0.01"}
                      placeholder={formData.menu_direction_type === "fixed" ? "e.g., 50" : "e.g., 10"}
                    />
                  </div>
                </>
              )}
            </div>
            <div style={{ marginTop: "20px" }}>
              <h4 style={{ ...styles.label, marginBottom: "12px", fontSize: "13px" }}>Menu Pages</h4>
              <div style={styles.documentGrid}>
                <FileUploadField label="Page 1" docKey="current_menu_page1" />
                <FileUploadField label="Page 2" docKey="current_menu_page2" />
                <FileUploadField label="Page 3" docKey="current_menu_page3" />
                <FileUploadField label="Page 4" docKey="current_menu_page4" />
                <FileUploadField label="Page 5" docKey="current_menu_page5" />
                <FileUploadField label="Page 6" docKey="current_menu_page6" />
                <FileUploadField label="Page 7" docKey="current_menu_page7" />
                <FileUploadField label="Page 8" docKey="current_menu_page8" />
                <FileUploadField label="Page 9" docKey="current_menu_page9" />
              </div>
            </div>
          </>
        );

      case "meta":
        return (
          <>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Subject</label>
              <input style={styles.input} name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject" />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Details</label>
              <textarea style={styles.textarea} name="details" value={formData.details || ""} onChange={handleChange} placeholder="Additional details" />
            </div>
            <div style={{ marginTop: "20px" }}>
              <div style={styles.infoRow}>
                <div style={styles.infoLabel}>Created By ID</div>
                <div style={styles.infoValue}>
                  <input style={styles.input} name="created_by_id" placeholder="Admin ID" value={formData.created_by_id} onChange={handleChange} />
                </div>
              </div>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  // ── Navigation buttons ──
  const goToNext = () => {
    const currentIndex = sections.findIndex((s) => s.id === activeSection);
    if (currentIndex < sections.length - 1) {
      setActiveSection(sections[currentIndex + 1].id);
    }
  };

  const goToPrev = () => {
    const currentIndex = sections.findIndex((s) => s.id === activeSection);
    if (currentIndex > 0) {
      setActiveSection(sections[currentIndex - 1].id);
    }
  };

  const currentIndex = sections.findIndex((s) => s.id === activeSection);
  const isLastSection = currentIndex === sections.length - 1;
  const isFirstSection = currentIndex === 0;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={handleCancel}>
          <BackIcon /> Back
        </button>
        <h2 style={styles.headerTitle}>{isEditMode ? "Edit Restaurant" : "Add New Restaurant"}</h2>
      </div>

      <div style={styles.progressContainer}>
        <div style={styles.progressHeader}>
          <span style={styles.progressLabel}>Form Completion</span>
          <span style={styles.progressPercent}>{Math.round(progressPercentage)}%</span>
        </div>
        <div style={styles.progressBarBg}>
          <div style={styles.progressBarFill} />
        </div>
      </div>

      <div style={styles.sectionButtons}>
        {sections.map((section) => (
          <button
            key={section.id}
            style={styles.sectionBtn(activeSection === section.id, filledSections[section.id])}
            onClick={() => setActiveSection(section.id)}
          >
            <span>{section.icon}</span>
            <span>{section.label}</span>
            {filledSections[section.id] && <CheckCircleIcon />}
          </button>
        ))}
      </div>

      <div style={styles.formContainer}>
        <div style={styles.formCard}>
          <div style={styles.formTitle}>{sections.find((s) => s.id === activeSection)?.label}</div>

          <form onSubmit={handleSubmit}>
            {renderForm()}

            <div style={styles.navButtons}>
              <button
                type="button"
                style={styles.navBtn}
                onClick={goToPrev}
                disabled={isFirstSection}
              >
                ← Previous
              </button>
              {!isLastSection ? (
                <button type="button" style={styles.navBtnPrimary} onClick={goToNext}>
                  Next →
                </button>
              ) : (
                <button type="submit" style={styles.navBtnPrimary} disabled={loading}>
                  {loading ? "Saving..." : isEditMode ? "Update Restaurant" : "Create Restaurant"}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>

      <div style={styles.fixedButtons}>
        <button style={styles.cancelBtn} onClick={handleCancel}>
          Cancel
        </button>
        <button style={styles.createBtn} onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : isEditMode ? "Update" : "Create"}
        </button>
      </div>
    </div>
  );
};

export default AddNewRestaurant;